import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import BuildMyEvent from './pages/BuildMyEvent';
import ManageUpcomingEvents from './pages/ManageUpcomingEvents';
import Users from './pages/Users';
import HumanResource from './pages/HumanResource';
import Categories from './pages/Categories';
import Settings from './pages/Settings';
import Analytics from './pages/Analytics';
import Tickets from './pages/Tickets';
import PromotersManagement from './pages/PromotersManagement';
import CustomerChatManagement from './pages/CustomerChatManagement';
import ChatQuestionsManagement from './pages/ChatQuestionsManagement';
import LeadsManagement from './pages/LeadsManagement';
import EnquiryManagement from './pages/EnquiryManagement';
import SupportedRegions from './pages/SupportedRegions';
import RawData from './pages/RawData';
import EventRequests from './pages/EventRequests';
import HomePageManagement from './pages/HomePageManagement';
import ServicesHeroManagement from './pages/ServicesHeroManagement';
import CalendarManagement from './pages/CalendarManagement';
import HomepageDescriptionManagement from './pages/HomepageDescriptionManagement';
import AdminLayout from './components/AdminLayout';
import ProtectedRoute from './components/ProtectedRoute';
import { useAuth } from './contexts/AuthContext';
import theme from './styles/theme';

function App() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        {!isAuthenticated ? (
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        ) : (
          <AdminLayout>
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/build-my-event" 
                element={
                  <ProtectedRoute>
                    <BuildMyEvent />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/manage-upcoming-events" 
                element={
                  <ProtectedRoute>
                    <ManageUpcomingEvents />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/event-requests" 
                element={
                  <ProtectedRoute>
                    <EventRequests />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/homepage-management" 
                element={
                  <ProtectedRoute>
                    <HomePageManagement />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/services-hero" 
                element={
                  <ProtectedRoute>
                    <ServicesHeroManagement />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/calendar-management" 
                element={
                  <ProtectedRoute>
                    <CalendarManagement />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/homepage-description" 
                element={
                  <ProtectedRoute>
                    <HomepageDescriptionManagement />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/users" 
                element={
                  <ProtectedRoute>
                    <Users />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/promoters-management" 
                element={
                  <ProtectedRoute>
                    <PromotersManagement />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/chat-management" 
                element={
                  <ProtectedRoute>
                    <CustomerChatManagement />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/chat-questions" 
                element={
                  <ProtectedRoute>
                    <ChatQuestionsManagement />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/leads" 
                element={
                  <ProtectedRoute>
                    <LeadsManagement />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/enquiry" 
                element={
                  <ProtectedRoute>
                    <EnquiryManagement />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/supported-regions" 
                element={
                  <ProtectedRoute>
                    <SupportedRegions />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/raw-data" 
                element={
                  <ProtectedRoute>
                    <RawData />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/human-resource" 
                element={
                  <ProtectedRoute>
                    <HumanResource />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/categories" 
                element={
                  <ProtectedRoute>
                    <Categories />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/analytics" 
                element={
                  <ProtectedRoute>
                    <Analytics />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/tickets" 
                element={
                  <ProtectedRoute>
                    <Tickets />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/settings" 
                element={
                  <ProtectedRoute requireAdmin>
                    <Settings />
                  </ProtectedRoute>
                } 
              />
              <Route path="/login" element={<Navigate to="/dashboard" replace />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </AdminLayout>
        )}
      </div>
    </ThemeProvider>
  );
}

export default App;
